import React, { memo } from 'react';
import { TimerDisplay } from './TimerDisplay';

export interface ActiveGame {
  gameId: string;
  whitePlayer: string;
  blackPlayer: string;
  timeControl: string;
  whiteTimer: number;
  blackTimer: number;
  activePlayer: 'white' | 'black' | null;
  moveCount: number;
  spectatorCount: number;
}

interface SpectatorGameCardProps {
  game: ActiveGame;
  onClick: () => void;
}

export const SpectatorGameCard: React.FC<SpectatorGameCardProps> = memo(({ game, onClick }) => {
  return (
    <div 
      onClick={onClick}
      style={{
        border: '1px solid #ddd',
        borderRadius: '8px',
        padding: '16px',
        cursor: 'pointer',
        backgroundColor: '#fff',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        transition: 'all 0.2s ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
        e.currentTarget.style.transform = 'translateY(-2px)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
        e.currentTarget.style.transform = 'translateY(0)';
      }}
    >
      <div style={{ marginBottom: '12px' }}>
        <div style={{ fontSize: '12px', color: '#666', marginBottom: '12px' }}>
          Time Control: {game.timeControl}
        </div>
        
        {/* Player 1 (White) */}
        <div style={{ marginBottom: '8px' }}>
          <div style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: '4px' }}>
            {game.whitePlayer}
          </div>
          <TimerDisplay 
            timer={game.whiteTimer} 
            isActive={game.activePlayer === 'white'}
          />
        </div>
        
        {/* VS separator */}
        <div style={{ fontSize: '12px', color: '#666', textAlign: 'center', margin: '8px 0' }}>
          vs
        </div>
        
        {/* Player 2 (Black) */}
        <div>
          <div style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: '4px' }}>
            {game.blackPlayer}
          </div>
          <TimerDisplay 
            timer={game.blackTimer} 
            isActive={game.activePlayer === 'black'}
          />
        </div>
      </div>
      
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        marginTop: '12px',
        paddingTop: '12px',
        borderTop: '1px solid #eee'
      }}>
        <div style={{ fontSize: '12px', color: '#666' }}>
          Moves: {game.moveCount}
        </div>
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: '4px',
          fontSize: '12px',
          color: '#666'
        }}>
          <span>👁️</span>
          <span>{game.spectatorCount}</span>
        </div>
      </div>
    </div>
  );
});
